export const redirectToLoginScreen = () => {
  const isLocal = window.location.host.includes("localhost");

  window.location.href = `${process.env.REACT_APP_FE_AUTH_DOMAIN}/logout?local=${isLocal}&sourceUrl=${process.env.REACT_APP_GALAXY_SOURCE_URL_REDIRECT_AFTER_SUCCESS_AUTH}`;
};
